/* tslint:disable */
/* eslint-disable */
/**
 * Token.WebApi v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface CoordinatesDto
 */
export interface CoordinatesDto {
  /**
   *
   * @type {number}
   * @memberof CoordinatesDto
   */
  latitude: number;
  /**
   *
   * @type {number}
   * @memberof CoordinatesDto
   */
  longitude: number;
}

/**
 * Check if a given object implements the CoordinatesDto interface.
 */
export function instanceOfCoordinatesDto(
  value: object,
): value is CoordinatesDto {
  if (!('latitude' in value) || value['latitude'] === undefined) return false;
  if (!('longitude' in value) || value['longitude'] === undefined) return false;
  return true;
}

export function CoordinatesDtoFromJSON(json: any): CoordinatesDto {
  return CoordinatesDtoFromJSONTyped(json, false);
}

export function CoordinatesDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CoordinatesDto {
  if (json == null) {
    return json;
  }
  return {
    latitude: json['latitude'],
    longitude: json['longitude'],
  };
}

export function CoordinatesDtoToJSON(json: any): CoordinatesDto {
  return CoordinatesDtoToJSONTyped(json, false);
}

export function CoordinatesDtoToJSONTyped(
  value?: CoordinatesDto | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    latitude: value['latitude'],
    longitude: value['longitude'],
  };
}
